import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const fundManagerSelector = ({ fundManager }: ReducerState) => fundManager;
export const fundManagerLoadingSelector = createSelector(
  fundManagerSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
